// Auto generated file, do not manually modify!
// com.hotpads.cometuserauth.api.getuser.web.handler.web.CometUserAuthenticationWebHandler

import type { QueryOptions, UseQueryOptions } from '@zg-rentals/react-query5';
import { useQuery } from '@zg-rentals/react-query5';
import { tsClientOptions } from '@zg-rentals/react-query5';
import type { Client } from '@zg-rentals/http-client';
import {
  CometUserAuthenticationWebHandler_getUser,
  CometUserAuthenticationWebHandler_getUser_Path,
} from '@zg-rentals/ts-satellite-client';

import type { AuthCheckUserInfoDto } from '@zg-rentals/ts-satellite-client';

interface GetUserParams {
  allowedSessionLengthSeconds?: number;
  pageWithSensitiveInformation?: boolean;
}

export type CometUserAuthenticationWebHandler_getUser_Options = UseQueryOptions<
  AuthCheckUserInfoDto,
  unknown,
  AuthCheckUserInfoDto,
  readonly [string, GetUserParams]
>;

const CometUserAuthenticationWebHandler_getUser_GetKey = (getParams: GetUserParams) =>
  [CometUserAuthenticationWebHandler_getUser_Path, getParams] as const;

export const CometUserAuthenticationWebHandler_getUser_queryOptions = (
  getParams: GetUserParams,
  { httpClient }: { httpClient?: Client } = {},
) =>
  ({
    ...tsClientOptions.queryOptions,
    queryKey: CometUserAuthenticationWebHandler_getUser_GetKey(getParams),
    queryFn: () => CometUserAuthenticationWebHandler_getUser(getParams, httpClient),
  }) as const satisfies QueryOptions;

/**
 * Get user auth status and some details
 */
export const useCometUserAuthenticationWebHandler_getUser = (
  getParams: GetUserParams,
  {
    httpClient,
    ...options
  }: Omit<CometUserAuthenticationWebHandler_getUser_Options, 'queryFn' | 'queryKey'> & { httpClient?: Client } = {},
) => {
  return useQuery({
    ...CometUserAuthenticationWebHandler_getUser_queryOptions(getParams, { httpClient }),
    ...options,
  });
};
useCometUserAuthenticationWebHandler_getUser.getKey = CometUserAuthenticationWebHandler_getUser_GetKey;
